import React from "react";
import { DsBadge, DsButton } from "../../../design-system";

/**
 * One payroll general setting: label + controls on one row + per-row Save (matches Enterprise defaults).
 */
export default function PayrollGeneralSettingRow({
  label,
  infoTitle = null,
  dirty = false,
  saving = false,
  disabled = false,
  onSave,
  children,
  footer = null,
}) {
  return (
    <div className="border-b border-[hsl(var(--ds-border))] py-4 last:border-b-0">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0 shrink-0 lg:max-w-[min(100%,280px)]">
          <div className="flex items-center gap-1.5 text-sm font-medium text-[hsl(var(--ds-fg))]">
            <span>{label}</span>
            {infoTitle ? (
              <span
                title={infoTitle}
                className="cursor-help font-normal text-[hsl(var(--ds-muted-fg))]"
                aria-label="More information"
              >
                ⓘ
              </span>
            ) : null}
          </div>
          <div className="mt-1.5">
            {dirty ? (
              <DsBadge tone="warning">Unsaved changes</DsBadge>
            ) : (
              <DsBadge tone="success">Saved</DsBadge>
            )}
          </div>
        </div>

        <div className="flex min-w-0 flex-1 flex-wrap items-center justify-end gap-2 sm:gap-3">
          {children}
          <DsButton
            type="button"
            size="sm"
            className="shrink-0"
            disabled={disabled || saving || !dirty}
            loading={saving}
            onClick={onSave}
          >
            {saving ? "Saving…" : "Save"}
          </DsButton>
        </div>
      </div>
      {footer ? <div className="mt-3 pl-0 lg:pl-[min(280px,28%)]">{footer}</div> : null}
    </div>
  );
}
